(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    /**
   * Submits the facet form as soon as a control changes, so the merchant's
   * filters behave like a normal faceted nav. Without this script the form
   * still works via its submit button.
   */
  class ZsFacets extends HTMLElement {
    connectedCallback() {
      this.classList.add('facets--js');
      this.form = this.querySelector('[data-facets-form]');
      if (!this.form) return;

      this.form.addEventListener('change', (event) => {
        // Let people finish typing a price before reloading the page.
        if (event.target.type === 'number') return;
        this.form.submit();
      });

      this.form.addEventListener('input', (event) => {
        if (event.target.type !== 'number') return;
        clearTimeout(this.priceTimer);
        this.priceTimer = setTimeout(() => this.form.submit(), 800);
      });
    }
  }

  if (!customElements.get('zs-facets')) {
    customElements.define('zs-facets', ZsFacets);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    /**
   * Gallery: thumbnail selection plus a <dialog> lightbox with keyboard
   * navigation. The <dialog> gives focus trapping and Escape handling for
   * free, so only arrow keys are wired up manually.
   */
  class ZsGallery extends HTMLElement {
    connectedCallback() {
      this.mainSlides = Array.from(this.querySelectorAll('[data-main-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.lightboxSlides = Array.from(this.querySelectorAll('[data-lightbox-slide]'));
      this.lightbox = this.querySelector('[data-lightbox]');
      this.index = 0;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.select(Number(thumb.dataset.index));
        });
      });

      const opener = this.querySelector('[data-open-lightbox]');
      if (opener && this.lightbox) {
        opener.addEventListener('click', () => {
          if (typeof this.lightbox.showModal === 'function') this.lightbox.showModal();
        });
      }

      const closer = this.querySelector('[data-close-lightbox]');
      if (closer && this.lightbox) {
        closer.addEventListener('click', () => this.lightbox.close());
      }

      const prev = this.querySelector('[data-lightbox-prev]');
      const next = this.querySelector('[data-lightbox-next]');
      if (prev) prev.addEventListener('click', () => this.select(this.index - 1));
      if (next) next.addEventListener('click', () => this.select(this.index + 1));

      if (this.lightbox) {
        // Clicking the backdrop area (the dialog itself, not the image) closes.
        this.lightbox.addEventListener('click', (event) => {
          if (event.target === this.lightbox) this.lightbox.close();
        });

        this.lightbox.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.select(this.index - 1);
          if (event.key === 'ArrowRight') this.select(this.index + 1);
        });
      }

      // The variant picker asks the gallery to jump to a variant's image.
      this.addEventListener('zs:gallery:select', (event) => {
        this.select(event.detail.index);
      });
    }

    select(target) {
      const count = this.mainSlides.length;
      if (!count) return;

      const next = ((target % count) + count) % count;
      this.setActive(this.mainSlides, next);
      this.setActive(this.lightboxSlides, next);

      this.thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === next);
        thumb.setAttribute('aria-pressed', i === next ? 'true' : 'false');
      });

      this.index = next;
    }

    setActive(nodes, index) {
      nodes.forEach((node, i) => {
        node.classList.toggle('is-active', i === index);
      });
    }
  }

  if (!customElements.get('zs-gallery')) {
    customElements.define('zs-gallery', ZsGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
